import { useMutation, useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { ApiClient } from './api.client.js';
import { type Event, type EventCategory, type EventPriority } from '../models/index.js';

export interface GetEventsForPatientsParams {
  patientIds: string[];
}

export interface CreateEventParams {
  category: EventCategory;
  patientId: string;
  start: string;
  priority: EventPriority;
  end?: string;
}

export const EventsApiKeys = {
  Events: 'Events',
  Event: 'Event',
};

export class EventsApi extends ApiClient {
  public static getEventsForPatients(params: GetEventsForPatientsParams): Promise<Event[]> {
    return this.http
      .get('/events', {
        params,
      })
      .then((res) => res.data);
  }

  public static createEvent(event: CreateEventParams): Promise<Event> {
    return this.http.post('/events', event).then((res) => res.data);
  }

  public static endEvent(id: string): Promise<Event> {
    return this.http.put<Event>(`/events/${id}/end`).then((res) => res.data);
  }
}

export function useEventsForPatients(params: GetEventsForPatientsParams, queryOptions?: UseQueryOptions<Event[]>) {
  return useQuery<Event[]>(
    [EventsApiKeys.Events, params.patientIds],
    () => EventsApi.getEventsForPatients(params),
    queryOptions,
  );
}

export function useCreateEvent() {
  return useMutation((event: CreateEventParams) => EventsApi.createEvent(event));
}

export function useEndEvent() {
  return useMutation((id: string) => EventsApi.endEvent(id));
}
